<template>
  <div class="app-container">
    <!-- <div class="detailsTitle">
      <h4>账单管理</h4>
    </div> -->
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData">
        <el-form-item label="创建时间:">
          <el-date-picker v-model="formData.createTimeStart" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>-
          <el-date-picker v-model="formData.createTimeEnd" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="结算状态:">
          <el-select v-model="formData.feeState" size="mini" placeholder="请选择" filterable clearable>
            <el-option v-for="(item, index) in jiesuanOptions" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账单号:">
          <el-input v-model="formData.feeNo" placeholder="请输入" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="仓库名称:">
          <el-select filterable v-model="formData.organizationName" size="mini" placeholder="请选择" clearable>
            <el-option v-for="(item,index) in addKuwei" :key="index" :label="item.tenantName" :value="item.tenantName"></el-option>
          </el-select>
        </el-form-item>
        <br />
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun" v-if="btnFlg[0]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" v-if="btnFlg[1]">重置</el-button>
          <!-- <el-button type="primary" size="mini" @click="daochu" v-if="btnFlg[2]">导出</el-button> -->
        </el-form-item>
        <el-form-item>
          <span>
            总金额：
            <span style="color: red">{{ feeMasterTotal }}</span> &nbsp;元
          </span>
          <span style="margin-left: 20px">
            已收款：
            <span style="color: red">{{ feeMasterTotalYes }}</span> &nbsp;元
          </span>
          <span style="margin-left: 20px">
            未收款：
            <span style="color: red">{{ feeMasterTotalNo }}</span> &nbsp;元
          </span>
        </el-form-item>
      </el-form>

    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" class="tableComent" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row @row-click="dianjixuanzhong">
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column width="150" label="操作" align="center">
          <template v-slot="scope">
            <el-button v-if="btnFlg[3]" type="text" @click="addzhangdan(scope.row,scope.row.feeMasterId)">账单明细</el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeNo" label="账单号" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="receivableFee" label="应收金额" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeStateName" label="状态" align="center">
          <template v-slot="scope">
            <span style='color:red;' v-show="scope.row.feeStateName == '未收款'">{{scope.row.feeStateName}}</span>
            <span v-show="scope.row.feeStateName == '已收款'">{{scope.row.feeStateName}}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
    <el-dialog v-loading="loading" title="账单明细" :visible.sync="zhangdanDetailVisible" :close-on-click-modal="false" width="90%" center :before-close="guanbi">
      <p>
        <span>费用合计：<span style="color:red">{{totalFee}}</span> 元</span>
        <span class="box">附加：<span style="color:red">{{additionalFee}}</span> 元</span>
        <span class="box">减免：<span style="color:red">{{deductionFee}}</span> 元</span>
        <span class="box">应收：<span style="color:red">{{YStotalFee}}</span> 元</span>
        <span class="box">费用备注：<span>{{feeRemark}}</span></span>
      </p>
      <hr>
      <el-table height="200px" size="mini" border center bordersize="mini" ref="tabref1" :data="tableDataMX" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row>
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeType" label="费用项目" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="pricingMethod" label="计价方式" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="unitPrice" label="单价" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeVolume" label="结算量" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="fee" label="金额" align="center"></el-table-column>
      </el-table>
      <div>
        <p>费用明细：</p>
        <el-table height="300px" size="mini" border center bordersize="mini" ref="table" :data="feeDetailList" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row>
          <el-table-column v-if="feeDetailList.length>0" type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" v-for="item in titleList" :key="item.titleName" :prop="item.titleId instanceof Array ?'':item.titleId" :label="item.titleName" align="center" :width="item.titleId=='cargoBarcode'||item.titleId=='customerName'||item.titleId=='outstockNo'||item.titleId=='instockDate'||item.titleId=='outstockDate'||item.titleId=='inCustomerName'?200:120">
            <template v-if="item.titleId instanceof Array ? true : false">
              <el-table-column v-for="item in item.titleId" :key="item.titleId" :prop="item.titleId" :label="item.titleName"></el-table-column>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="guanbi">关闭</el-button>
      </div>
    </el-dialog>
    <!--点击查看凭证-->
    <div class="addMarkBox">
      <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="60%" center>
        <!-- <div v-if="!imgFlag">
            <div>无货损图片</div>
          </div>-->
        <div class="img_box">
          <div v-for="(item, index) in imgData" :key="index">
            <img :src="item.url" alt />
            <!-- <i v-if="seen" class="el-icon-delete" @click="delImg(item)"></i> -->
            <i class="el-icon-zoom-in" @click="handChange(item.url)"></i>
          </div>
        </div>
        <el-dialog class="oneTwo" :visible.sync="dialogVisible" title="查看凭证" append-to-body width="40%" center :close-on-click-modal="false">
          <div class="imgDialog">
            <img :src="imageD" alt />
          </div>
        </el-dialog>
        <div style="width: 158px; margin: 15px auto"></div>
      </el-dialog>
    </div>
    <billsDetail v-if="zhangdanDetailVisibles" :zhangdanDetailVisible.sync="zhangdanDetailVisibles" :feeMasterId="feeMasterId"></billsDetail>
  </div>
</template>

<script>
import { JfgetFeeMasterList, getFeeList, getFeeMasterTotal } from '@/api/wms-stock'

import { exportExcel } from '@/utils/fileDown.js'
import DonMessage from '@/utils/message'
import {
  getCargoDamagePicture // 查看图片
} from '@/api/wms-access'
import { getBtn } from '@/utils/getButton'
import billsDetail from './billsDetail.vue'
import { getAllTenantData } from '@/api/platform-settlement'

export default {
  name: 'billManagement',
  components: { billsDetail },
  data () {
    return {
      formData: {
        createTimeStart: '',
        createTimeEnd: '',
        feeState: '0',
        feeNo: '',
        organizationName: '',
        feeType: '1'
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      h: '500px',
      jiesuanOptions: [
        { id: '', name: '全部' },
        { id: '0', name: '未收款' },
        { id: '1', name: '已收款' }
      ],
      tableData: [],
      xuanzhongArr: null,
      total: 0,
      zhangdanDetailVisible: false,
      loading: false,
      DetailtableData: [],
      tableDataMX: [],
      // feeDetailList: { cargoList: [], titleList: [] },
      feeDetailList: [],
      titleList: [],
      feeNo: '',
      payCustomerName: '',
      feeStateName: '',
      remark: '',
      storageFee: '',
      additionalFee: '',
      deductionFee: '',
      totalFee: '',
      YStotalFee: '',
      feeRemark: '',
      addMarkLookBox: false,
      imageD: '',
      dialogVisible: false,
      imgData: [],
      keHuOptions: [],
      btnFlg: [],
      btnIdArr: ['0130040100', '0130040200', '0130040300', '0130040400'],
      zhangdanDetailVisibles: false,
      feeMasterId: '',
      feeMasterTotal: 0,
      feeMasterTotalNo: 0,
      feeMasterTotalYes: 0,
      addKuwei: []
    }
  },
  methods: {
    getAllTenantData () {
      getAllTenantData().then(res => {
        console.log(res)
        this.addKuwei = res
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 查看凭证-放大
    handChange (url) {
      this.imageD = url
      this.dialogVisible = true
    },
    // 图片查看
    imgShow (row) {
      this.addMarkLookBox = true
      getCargoDamagePicture({
        cargoId: row.cargoId // 货物id
      })
        .then((res) => {
          this.imgData = []
          this.imgData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    chaxun () {
      JfgetFeeMasterList(
        {
          ...this.pageInfo,
          ...this.formData
        }
      )
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
          this.xuanzhongArr = null
        })
        .catch(error => {
          this.$message({ message: error.message, type: 'error' })
        })
      getFeeMasterTotal({ ...this.formData })
        .then(res => {
          this.feeMasterTotal = res.feeMasterTotal
          this.feeMasterTotalNo = res.feeMasterTotalNo
          this.feeMasterTotalYes = res.feeMasterTotalYes
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    chongzhi () {
      this.formData.createTimeStart = ''
      this.formData.createTimeEnd = ''
      this.formData.feeState = '0'
      this.formData.feeNo = ''
      this.formData.organizationName = ''
      this.chaxun()
    },
    // daochu () {
    //   if (this.xuanzhongArr == null) {
    //     this.$message({ message: '请先选择一条数据', type: 'error' })
    //     return
    //   }
    //   if (this.xuanzhongArr.feeType == 1) {
    //     this.$message.error('此账单为盘库账单')
    //     return
    //   }
    //   exportExcel(
    //     this.global.wmsStockName + '/storageFee/exportStorageFeeList',
    //     { ...this.formData, feeMasterId: this.xuanzhongArr.feeMasterId },
    //     '账单管理'
    //   )
    // },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      // this.JfgetThreadDetailExpLists()
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    getFeeList (row) {
      getFeeList(
        {
          feeMasterId: row.feeMasterId
        }
      )
        .then(res => {
          this.zhangdanDetailVisible = true
          this.tableDataMX = res.feeUpList
          console.log(res)
          this.feeDetailList = res.feeList
          this.titleList = res.titleList
          // if (res.length > 0) {
          //   this.tableDataMX = res
          //   this.feeDetailList = res[0].listmap
          // }
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 账单明细
    addzhangdan (row, val) {
      if (row.feeType == '1') {
        this.zhangdanDetailVisibles = true
        this.feeMasterId = row.feeMasterId
        return
      }
      this.getFeeList(row)

      // this.feeNo = row.feeNo
      // this.payCustomerName = row.payCustomerName
      // this.feeStateName = row.feeStateName
      // this.remark = row.remark
      // this.storageFee = row.storageFee
      this.additionalFee = row.additionalFee
      this.deductionFee = row.deductionFee
      this.totalFee = row.totalFee
      this.YStotalFee = row.receivableFee
      this.feeRemark = row.feeRemark
      // JfgetStorageFeeList(
      //   {
      //     feeMasterId: val
      //   }
      // )
      //   .then(res => {
      //     console.log(res)
      //     this.DetailtableData = res
      //     // this.total = res.total
      //   })
      //   .catch(error => {
      //     this.$message({ message: error.message, type: 'error' })
      //   })
    },
    guanbi () {
      this.zhangdanDetailVisible = false
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 155 + 'px'
    this.btnFlg = getBtn(this.btnIdArr, '/billManagement')
    this.chaxun()
    this.getAllTenantData()
  }
}
</script>

<style lang="less" scoped>
.box {
  margin-left: 30px;
}
/deep/.el-form-item {
  margin-bottom: 0;
}
</style>
